<template>
  <div class="left-steps">
    <div class="item" v-for="(item, index) in data" :key="index" @click="change(index)">
      <div :class="[value >= index ? 'cur' : 'no-selected']"
        :style="{ 'background-image': `url(${require(`@/assets/menu/${value >= index ? `m-${index}-cur` : 'no-selected'}.png`)})` }">
        <span>{{ `0${index + 1}` }}</span>
        <strong>{{ item.name }}</strong>
      </div>
      <icon-next-arrow class="arrow" v-if="index < data.length - 1"></icon-next-arrow>
    </div>
  </div>
</template>

<script>
import IconNextArrow from '../../../../components/Icon/IconNextArrow'
export default {
  name: 'LeftSteps',
  components: { IconNextArrow },
  props: {
    value: {
      type: Number,
      default: 0,
    },
    data: {
      type: Array,
      default: () => {
        return [{ name: '测试' }]
      }
    }
  },
  data() {
    return {
      css1: {
        height: '39px',
        background: 'gray'
      },
      blue: 'blue'
    }
  },
  mounted() {
  },
  methods: {
    change(index) {
      this.$emit('change', index)
    }
  }
}
</script>

<style scoped lang="less">
.left-steps {
  height: calc(100vh - 56px);
  overflow: auto;
  padding: 12px 0;

  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: rgba(255, 255, 255, 0.4);
    cursor: pointer;

    .cur,
    .no-selected {
      width: 76px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-evenly;
      background-repeat: no-repeat;
      background-position: center top;
      font-size: 12px;

      span {
        font-style: italic;
        font-weight: bolder;
      }
    }


    .cur {
      height: 58px;
      padding-top: 32px;
      color: white;
    }
    .no-selected {
      height: 24px;
      border-radius: 5px;
      background-color: rgba(150, 150, 150, .3);

      span {
        color: rgba(55, 110, 255, 1);
      }

      strong {
        color: white;
      }
    }

    .arrow {
      //margin: 5px 0;
    }
  }
}
</style>